import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./investorsform.css";
import { IoClose } from "react-icons/io5";
import { FiRefreshCw } from "react-icons/fi";
import CustomDropdown from "../../Common/CustomDropdown";

/* IMAGES */
import TargetSalesImg from "../../../Assets/Forms/1.png";
import AiFeaturesImg from "../../../Assets/Forms/2.png";
import StoreBrush from "../../../Assets/Forms/3.png";
import BadgeIcon from "../../../Assets/Icons/ai-star.png";

import InvestmentSuccess from "./InvestmentSuccess.jsx";

const STORAGE_KEY = "fulupo_investor_form_data";

const InvestorsForm = ({ isOpen, onClose }) => {
    const [successOpen, setSuccessOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [captcha, setCaptcha] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");
    const [formData, setFormData] = useState(() => {
        const defaultState = {
            fullName: "",
            investmentRange: "",
            phone: "",
            email: "",
            details: ""
        };
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                return { ...defaultState, ...parsed };
            } catch (e) {
                console.error("Error parsing saved form data", e);
            }
        }
        return defaultState;
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
    }, [formData]);

    const investmentOptions = [
        "Less than ₹10 Lakh",
        "₹10 Lakh – ₹50 Lakh",
        "₹50 Lakh – ₹1 Crore",
        "More than ₹1 Crore"
    ];

    const generateCaptcha = () => {
        const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789@#";
        let result = "";
        for (let i = 0; i < 5; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setCaptcha(result);
    };

    useEffect(() => {
        if (isOpen || successOpen) {
            // Push item to history to intercept back button
            window.history.pushState({ modal: "investor" }, "");

            const handlePopState = () => {
                onClose();
            };

            window.addEventListener("popstate", handlePopState);
            return () => {
                window.removeEventListener("popstate", handlePopState);
            };
        }
    }, [isOpen, successOpen, onClose]);

    useEffect(() => {
        if (isOpen) {
            generateCaptcha();
        }
    }, [isOpen]);

    useEffect(() => {
        document.body.style.overflow = isOpen || successOpen ? "hidden" : "auto";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen, successOpen]);


    if (!isOpen && !successOpen) return null;

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone") {
            const digits = value.replace(/\D/g, "");
            if (digits.length <= 10) {
                setFormData(prev => ({ ...prev, phone: digits }));
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }

        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: false }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {};
        if (!formData.fullName?.trim()) newErrors.fullName = "Full name is required";
        if (!formData.investmentRange) newErrors.investmentRange = "Please select an investment range";

        if (!formData.email?.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!formData.phone.trim() || formData.phone.length !== 10) {
            newErrors.phone = "Phone number must be 10 digits";
        }

        if (captchaInput !== captcha) {
            newErrors.captcha = "Captcha is incorrect";
            generateCaptcha();
            setCaptchaInput("");
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setIsLoading(true);

        const payload = {
            name: formData.fullName,
            mobileNumber: formData.phone,
            email: formData.email,
            selectRange: formData.investmentRange,
            additionalDetails: formData.details?.trim() || "NA"
        };

        try {
            const response = await fetch("https://fulupostore.tsitcloud.com/api/partnerForm/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.success) {
                setSuccessOpen(true);
                localStorage.removeItem(STORAGE_KEY);
                setFormData({
                    fullName: "",
                    investmentRange: "",
                    phone: "",
                    email: "",
                    details: ""
                });
            } else {
                console.error("Submission failed:", data.message);
                alert("Submission failed: " + (data.message || "Unknown error"));
            }
        } catch (err) {
            console.error("Network error:", err);
            alert("Network error. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return ReactDOM.createPortal(
        <>
            {/* FORM 1 */}
            {isOpen && !successOpen && (
                <div className="modal-overlay">
                    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                        <button className="closed-x" onClick={onClose}>
                            <IoClose />
                        </button>
                        <div className="modal-card">

                            {/* LEFT */}
                            <div className="modal-left">
                                <span className="ai-badge">
                                    <img src={BadgeIcon} alt="" className="ai-badge-icon" />
                                    Investment Opportunities
                                </span>

                                <h1 className="modal-title">
                                    Fueling the <br />
                                    future of Quick <br />
                                    <span className="store-brush-wrap">
                                        <span className="text-green">commerce</span>
                                        <img src={StoreBrush} className="store-brusher" alt="" />
                                    </span>
                                </h1>

                                <p className="modal-description">
                                    Fulupo is revolutionizing quick commerce with cutting-edge technology and unparalleled delivery speed.
                                </p>

                                <div className="feature-list">
                                    <div className="feature-item">
                                        <span className="star-icon">⭐</span>
                                        <span>Proven Positive Unit Economics</span>
                                    </div>
                                    <div className="feature-item">
                                        <span className="star-icon">⭐</span>
                                        <span>High-Retention Customer Base</span>
                                    </div>
                                </div>

                                <div className="stats-stack">
                                    <div className="stat-card card-growth">
                                        <img src={TargetSalesImg} alt="" />
                                        <div className="stat-content">
                                            <span className="stat-label">YoY Growth</span>
                                            <strong className="stat-value">300%</strong>
                                        </div>
                                    </div>

                                    <div className="stat-card card-leadership">
                                        <img src={AiFeaturesImg} alt="" />
                                        <div className="stat-content">
                                            <span className="stat-label">Strategic</span>
                                            <strong className="stat-value">Market Leadership</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT */}
                            <div className="modal-right">
                                <h2 className="form-title">
                                    Investment Enquiry
                                </h2>

                                <form onSubmit={handleSubmit}>
                                    <input
                                        className={`form-input ${errors.fullName ? "error" : ""}`}
                                        name="fullName"
                                        placeholder="Full Name *"
                                        value={formData.fullName}
                                        onChange={handleInputChange}
                                    />



                                    <input
                                        className={`form-input ${errors.phone ? "error" : ""}`}
                                        name="phone"
                                        placeholder="Phone Number *"
                                        maxLength={10}
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                    />

                                    <div className="investment-range-field">
                                        <CustomDropdown
                                            className="dropdown-no-bottom-radius dropdown-show-all"
                                            options={investmentOptions}
                                            value={formData.investmentRange}
                                            onChange={(val) => {
                                                setFormData(prev => ({ ...prev, investmentRange: val }));
                                                if (errors.investmentRange) setErrors(prev => ({ ...prev, investmentRange: false }));
                                            }}
                                            placeholder="Select Investment Range *"
                                            error={errors.investmentRange}
                                            icon={<span className="rupee-icon" style={{ marginRight: '8px', fontSize: '16px', color: '#888' }}>₹</span>}
                                        />
                                    </div>


                                    <input
                                        className={`form-input ${errors.email ? "error" : ""}`}
                                        name="email"
                                        placeholder="Email Address *"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />

                                    <textarea
                                        className="form-input text-area"
                                        name="details"
                                        placeholder="Additional Details"
                                        value={formData.details}
                                        onChange={handleInputChange}
                                    />

                                    <div className="captcha-wrapper">
                                        <div className="captcha-section">
                                            <div className="captcha-box">{captcha}</div>

                                            <button
                                                type="button"
                                                className="captcha-refresh"
                                                onClick={() => {
                                                    generateCaptcha();
                                                    setCaptchaInput("");
                                                    setErrors(prev => ({ ...prev, captcha: false }));
                                                }}
                                            >
                                                <FiRefreshCw />
                                            </button>

                                            <input
                                                type="text"
                                                className={`captcha-input-2 ${errors.captcha ? "error-input" : ""}`}
                                                placeholder="Enter Captcha"
                                                value={captchaInput}
                                                onChange={(e) => {
                                                    setCaptchaInput(e.target.value);
                                                    if (errors.captcha) setErrors(prev => ({ ...prev, captcha: false }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <button className="submit-btn" type="submit" disabled={isLoading}>
                                        {isLoading ? (
                                            <div className="loader-container">

                                                <div className="spinner"></div>
                                            </div>
                                        ) : (
                                            "Submit Enquiry"
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* FORM 2 */}
            {successOpen && (
                <InvestmentSuccess
                    onClose={() => {
                        setSuccessOpen(false);
                        onClose();
                    }}
                />
            )}
        </>,
        document.body
    );
};

export default InvestorsForm;
